<template>
    <section class="steps">
        <div class="text">
            <h2>{{ config.BRIEF_STEPS_TITLE }}</h2>
            <p>{{ config.BRIEF_STEPS_DESCRIPTION }}</p>
        </div>
        <div v-if="pdf" class="downloadButton">
            <Button :color="config.COLOR_PRIMARY" outline>
                <a :href="pdf" target="_blank">{{ config.BRIEF_STEPS_DOWNLOAD }}</a>
            </Button>
        </div>
        <div v-if="config.BRIEF_STEPS_IMAGE || briefVideoUrl" class="visual">
            <Picture v-if="config.BRIEF_STEPS_IMAGE" :src="config.BRIEF_STEPS_IMAGE" :ratio="16/9" rounded size="cover"/>
            <Video v-else :src="briefVideoUrl" rounded/>
        </div>
        <div class="steps" :class="{'fullWidth': !config.BRIEF_STEPS_IMAGE && !briefVideoUrl }">
            <BriefStep v-for="(step, index) in steps" :key="index" :step="step" :order="index + 1"/>
        </div>
    </section>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { BriefStep } from '../../components/shared';

export default {
    name: 'BriefSteps',
    components: { BriefStep },
    mixins: [SolutionConsumer],
    props: {
        steps: {
            type: Array,
            required: true,
        },
        video: {
            type: String,
            required: true,
        },
        pdf: {
            type: String,
            default: null,
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

section {
    @include brief-section-grid();
    row-gap: 1rem;

    > .text {
        text-align: center;
        grid-column: 1 / 3;
    }

    > .downloadButton {
      grid-column: 1 / 3;
    }

    > .steps {
        display: grid;
        gap: 16px;
        align-items: flex-start;

        &.fullWidth {
          grid-column: 1 / 3;
        }
    }
}
</style>
